export const FACILITIES_CONFIG = {
  registrationDate: {
    key: "registrationDate",
    label: "Fecha de Registro",
  },
  facilityName: {
    key: "name",
    label: "Nombre del Inmueble",
  },
  contactName: {
    key: "contact",
    label: "Nombre del Contacto",
  },
  contactNumber: {
    key: "contactPhone",
    label: "Telefono del Contacto",
  },
  regimen: {
    key: "segment",
    label: "Regimen",
  },
  route: {
    key: "route",
    label: "Ruta",
  },
  station: {
    key: "station",
    label: "Planta",
  },
  fullAddress: {
    key: "fullAddress",
    label: "Domicilio",
  },
  street: {
    key: "street",
    label: "Calle",
  },
  extNumber: {
    key: "extNumber",
    label: "No Exterior",
  },
  intNumber: {
    key: "intNumber",
    label: "No Interior",
  },
  postalCode: {
    key: "postalCode",
    label: "Codigo Postal",
  },
  colony: {
    key: "colony",
    label: "Colonia",
  },
  municipality: {
    key: "municipality",
    label: "Municipio",
  },
  state: {
    key: "state",
    label: "Estado",
  },
  reference: {
    key: "reference",
    label: "Referencia",
  },
  paymentCycle: {
    key: "collectPeriod",
    label: "Periodo de Cobro",
  },
  notes: {
    key: 'notes',
    label: 'Notas'
  },
  discount: {
    key: 'discount',
    label: 'Descuento por litro'
  },
  adminCost: {
    key: 'adminCost',
    label: 'Costo Administración'
  },
  reconnectionCost: {
    key: 'reconnectionCost',
    label: 'Costo Reconexión'
  }
};

export const FACILITIES_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Inmuebles",
    },
  },
  modal: {
    titles: {
      edit: "Modificar Inmueble",
      add: "Agregar Nuevo Inmueble",
      delete: "¿Estas seguro de eliminar este inmueble?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
    },
  },
  modalDiscount: {
    title: "Asignar Cargos y Descuentos",
    actions: {
      cancel: "Cancelar",
      assing: "Asignar"
    }
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
  form: {
    dropdowns: {
      route: "Seleccione una Routa",
      station: "Seleccione una Planta",
      paymentCycle: "Seleccione un Perido de Cobro",
    },
  },
};
